import type { VaultContact } from '@shared/types';

export type DirectGuestPermissions = {
  canMessage: boolean;
  canCall: boolean;
  canDirectFileTransfer: boolean;
};

export function isDirectGuestContact(contact: VaultContact | null | undefined): boolean {
  return contact?.relationshipKind === 'direct_guest' && !!contact.directGuest;
}

export function getDirectGuestRoleLabel(contact: VaultContact | null | undefined): string | null {
  if (!isDirectGuestContact(contact)) return null;
  return contact!.directGuest!.role === 'guest' ? 'Guest' : 'External';
}

export function getDirectGuestPermissionLabel(permissions: DirectGuestPermissions | null | undefined): string {
  if (!permissions) return 'Limited access';
  const parts: string[] = [];
  if (permissions.canMessage) parts.push('messages');
  if (permissions.canCall) parts.push('calls');
  if (permissions.canDirectFileTransfer) parts.push('direct files');
  return parts.length > 0 ? parts.join(', ') : 'No access';
}

export function canDirectGuestSendMessages(contact: VaultContact | null | undefined): boolean {
  if (!isDirectGuestContact(contact)) return true;
  return !!contact!.directGuest!.canMessage;
}

export function canDirectGuestStartCalls(contact: VaultContact | null | undefined): boolean {
  if (!isDirectGuestContact(contact)) return true;
  return !!contact!.directGuest!.canCall;
}

export function canDirectGuestTransferFiles(contact: VaultContact | null | undefined): boolean {
  if (!isDirectGuestContact(contact)) return true;
  return !!contact!.directGuest!.canDirectFileTransfer;
}
